import { Box, Heading, useDisclosure } from '@chakra-ui/react';
import { FC, useState } from 'react';
import AddButton from '../../../components/Generic/Buttons/AddButton';
import MainContent from '../../../components/Generic/MainContent';
import CoupomList from '../components/CoupomList';
import CreateCoupomModal from '../components/CreateModal';
import {
  CreateListContext,
  ListContextDefaultValue,
  ListContextValue,
} from '../context/ListContext';

const CreateCoupom: FC = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  return (
    <>
      <AddButton onClick={onOpen}>Adicionar Cupom</AddButton>
      <CreateCoupomModal isOpen={isOpen} onClose={onClose} />
    </>
  );
};

const Main: FC = () => {
  const updateList = useState<ListContextValue>(ListContextDefaultValue);
  return (
    <>
      <Heading mb="48px" color="#469BFF" fontFamily="Poppins">
        Cupons
      </Heading>
      <Box bg="whiteAlpha.700" p="6" rounded="lg" boxShadow="md">
        <CreateListContext.Provider value={updateList}>
          <CreateCoupom />
          <CoupomList />
        </CreateListContext.Provider>
      </Box>
    </>
  );
};

export const CouponsPage: FC = () => {
  return (
    <MainContent>
      <Main />
    </MainContent>
  );
};
